import { chatActions } from "./chat-slice";





export const initSocket = (socket) => {
    return dispatch => {
        
        
        dispatch(chatActions.setSocket({socket: {id: socket.id}}))
       
                                       
        
        
    } 
}

export const saveSocket = (token, socketId) => {
    return async (dispatch) => {
        const setSocket = async () => {
            const fetchQuery = {
                query: `
                    query initSocket($socketId: ID!) {
                        setSocket(socketId: $socketId) 
                    }
                `,
                variables: {
                    socketId: socketId
                }
            }

            const response = await fetch('https://realyou.herokuapp.com/graphql', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(fetchQuery)
            })

            return await response.json()
        }

        try{
            const data = await setSocket()
            if(data.errors) return;

        }catch(err) {
             dispatch(chatActions.setGlobalError(err.message))
        }
    }
}


export const addUser = (newUser) => {
    return async dispatch => {
        dispatch(chatActions.addNewUser(newUser))
    }
}

export const setFriendsList = (userId, token) => {

    return async dispatch => {
        const fetchFriends = async () => {
            const getFriendsQuery = {
                query: `
                    query getFriendss($userId: String!) {
                        getFriends(userId: $userId){
                           roomId{
                               _id
                               
                               messages{
                                   text
                                   sender
                               }
                           }
                           id {
                               name
                               _id

                           }
                           
                        }
                    }
                `,
                variables: {
                    userId: userId.toString()
                }
            }

            const response = await fetch('https://realyou.herokuapp.com/graphql', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(getFriendsQuery)
            }).catch(err => {
                 dispatch(chatActions.setGlobalError(err.message))
            })

            return await response.json()
        }

        try{
            const data = await fetchFriends();
            if(data.errors) return;


            dispatch(chatActions.setFriendsList({friends: data.data.getFriends.map(f => {
                return {_id: f.id._id, name: f.id.name, roomId: f.roomId._id}
            })}))
            
        }catch(err) {
             dispatch(chatActions.setGlobalError(err.message))
        }

    }
}


export const getMessages = (roomId, token, setIsLoading) => {
    return async dispatch => {
        const fetchMessages = async () => {
            const fetchQuery = {
                query: `
                    query getMsgs($roomId: ID!) {
                        getMessages(roomId: $roomId) {
                            _id
                            users {
                                _id
                                name
                            }
                            messages {
                                _id
                                text
                                sender
                            }
                        }
                    }

                `,
                variables : {
                    roomId: roomId || ''
                }
            }

            const response = await fetch('https://realyou.herokuapp.com/graphql', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(fetchQuery)
            })

            return await response.json()

        }

        try {
            const data = await fetchMessages();
            if(data.errors) return;

            dispatch(chatActions.getMessages({messages: data.data.getMessages.messages}))
            
            setIsLoading(false)

        }catch(err) {
             dispatch(chatActions.setGlobalError(err.message))
        }
    }
}